require.register("modules/m03/m03-activity/page-9a/page-9a", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page9a = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {
    view.subscribeEvent('block:values:change', (e) => {
      view.$('form').submit();
    });
  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page9a;

  
});

